import React from 'react'
import { graphql } from "gatsby"
import { connect } from 'react-redux';

import Layout from '../layouts/layout'
import Filter from '../components/filter/filter';

import {
  extractCareers,
  getCareersTags
} from '../utils/selectors';

import {
  Container,
  Title
} from '../styles/articles';
import { setCareersFilter } from '../store/actions';
import CareerCard from '../components/career-card/careerCard';

class Index extends React.Component {
  onFiltersUpdated = filter => {
    this.props.updateFilter(filter);
  };

  render() {
	const {careersFilter} = this.props;

    const articles = extractCareers(this.props.data.allPrismicJobpost);
    //console.log(articles);
	const tags = getCareersTags(articles);
	
    const filterCategories = [ {
		name: 'tags',
		displayName: '',
		options: tags
    },
	{
	  name: 'region',
	  displayName: '',
	  options: []
	}];

    const labels = this.props.data.allPrismicCareers.edges[0].node.data;

    return (
      <Layout isWhite>
        <Container>
          <Title>{ labels.page_title.text }</Title>
          <Filter
            hideSearch = { false }
            singleFiltersOnly
            categories = { filterCategories }
            items = { articles }
            itemRenderer = { CareerCard }
            onItemClicked = { () => {} }
            customFilterClasses = "articleFilterContainer"
            customResultsClasses = "articleResultsContainer"
            onFiltersUpdated = { (filter) => this.onFiltersUpdated(filter) }
            initialFilters = { careersFilter }
            filterLabel = { labels.filter_label }
            searchLabel = { labels.search_label }
            searchBoxLabel = { labels.search_box_label }
          />
        </Container>
      </Layout>
    );
  }
}

export const query = graphql`
query GetCareersContent {
    allPrismicJobpost(sort: { fields: data___datetime , order:DESC }) {
        edges {
            node {
                ...Jobpost
            }
        }
    }

    allPrismicCareers {
        edges {
            node {
                data {
                    component_identifier {
						text
					}
					filter_label
					page_title {
						text
					}
					search_box_label
					search_label
                }
            }
        }
    }
}`;

const mapStateToProps = state => ({
  careersFilter: state.careersFilter,
});

const mapDispatchToProps = dispatch => ({
  updateFilter: filter => dispatch(setCareersFilter(filter))
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
